/* eslint-disable
    block-scoped-var,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import FileStates from 'FileStates';

class SingleFragmentSlotView extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'li';

    this.prototype.fileStates = FileStates.get();
  }

  events() {
    return {
      'click .js-delete': 'deleteSlot',
      'click .js-shift-left': 'shiftLeft',
      'click .js-shift-right': 'shiftRight',
      'click .js-insert-spacer': 'insertSpacer',
    };
  }

  initialize(options) {
    this.isRemoved = false;
    this.listeningSequences = [];
    this.listenTo(this.model, 'change:active slotChange', this.render);
    this.listenTo(this.fileStates, 'reset add remove', this.listenToSequences);
    this.listenTo(this.model.fragments(), 'add remove change:sequenceID', this.listenToSequences);
    this.listenToSequences();
  }

  listenToSequences() {
    if (this.isRemoved) {
      return;
    }

    for (var _sequence of Array.from(this.listeningSequences)) {
      this.stopListening(_sequence);
    }
    this.listeningSequences = _.compact(
      this.model.fragments().map((fragment) => {
        _sequence = __guard__(fragment.getSequence(), (x) => x.get('_sequence'));
        if (_sequence == null) {
          return null;
        }
        this.listenTo(_sequence, 'change:bases change:circular', () => {
          fragment.stopListening();
          fragment.destroy({
            error() {
              // Assert false for now to get a stack trace to help with debugging T571
              assertAndContinue(false, 'fragment.destroy() failed');
            },
          });
        });
        return _sequence;
      })
    );
  }

  shiftLeft() {
    this.model.shiftLeft();
  }

  shiftRight() {
    this.model.shiftRight();
  }

  insertSpacer() {
    const index = this.model.index() + 1;
    this.model.collection.addSlot({name: '', spacer: ''}, index);
  }

  deleteSlot() {
    if (this.$('.js-delete').hasClass('is-disabled')) {
      return;
    }
    this.model.destroy();
  }

  toggleDelete() {
    const notDeletable = !this.model.isSpacer() && this.model.index() === 0;
    this.$('.js-delete').toggleClass('is-disabled', notDeletable);
  }

  updateSequence(sequence) {
    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    this.sequence = sequence;
    this.selection = sequence != null ? sequence.get('selection') : undefined;
  }

  remove() {
    this.isRemoved = true;
    this.$('[data-toggle="tooltip"]').tooltip('destroy');
    return super.remove();
  }
}
SingleFragmentSlotView.initClass();

export default SingleFragmentSlotView;

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
